import router from '@/router';
import routes from '@/router/routes';
import { obj } from '@/util'
import { _USER } from "@/state";
import _ from 'lodash'

export class navHelper {

	constructor(obj = {}) {
		this.appRoutes = obj.appRoutes || []
		return this;
	}

	/**
	 * return fresh instance to update property and state
	 */
	return = () => new this.constructor(this)

    /*
    |-------------------------------------------------------------
    | Setup
    |-------------------------------------------------------------
    */

	/**
	 * setNavTree
	 */
	setNavTree = (data) => {
		this.appRoutes = data
			.map(i => this.parseItemInfo(i, i.route))
			.filter(i => !!i.visibility && !!i.title)
			.map(i => {

				let children = (i.children || [])
					.map(c => this.parseItemInfo(c, c.route))
					.filter(cr => _USER().isAbleToAny(cr.gate))		
				
				if (!_USER().isAbleToAny(i.gate)) {
					let exstingChildren = children
					i = _.first(children) || {}
					i.children = exstingChildren.filter(r => r.route && r.route != i.route)
				}
				else if (children.length == 1 && children[0].route == i.route) {
					i.children = [];
				}
				return i;
			})
			.filter(r => !!r.visibility)
		return this.return();
	}

	/**
	 * getNavNodes
	 */
	getNavNodes = () => (this.appRoutes || [])

	/**
	 * getNestedRoutes
	 */
	getNestedRoutes = (name = '') => {
		let routes = routes.find(r => r.name == name);
		return routes.children || [];
	}

    /*
    |-------------------------------------------------------------
    | Route Info
    |-------------------------------------------------------------
    */
	
	/**
	 * parseItemInfo
	 */
	parseItemInfo = (data, route = false) => {
		route = this.findRouteDeep(route)
		data.visibility ??= true
		return Object.assign({
			id			: '',
			title		: '',
			icon 		: '',
			class 		: '',
			disabled	: false,
			href 		: '#',
			click		: () => {},
			children	: [],
			gate		: []
		},(route.meta || {}),data);
	}
	
	/**
	 * findRoute
	 */
	findRoute = (value, key = 'name') => {
		return routes.find(r => r[key] == value) || {};
	}

	/**
	 * findRouteDeep
	 * @param {*} name 
	 * @returns 
	 */
	findRouteDeep = (value, key = 'name')  => {
		return obj.deepFind(routes, key, value, 'children') || {};
	}

	/**
	 * currentRoute
	 * @returns string
	 */
	currentRoute = () => {
		return router.currentRoute._value.name
	}

	/**
	 * activeRoute
	 * @returns object
	 */
	activeRoute = () => {
		let current = this.currentRoute();
		return this.parseItemInfo({},current);
	}

	/**
	 * activeRoute
	 * @returns boolean
	 */
	isActiveRoute = (name) => {
		return name == this.currentRoute();
	}

	/**
	 * getRouteConfig
	 * @returns mixed
	 */
	getRouteConfig = (name = '', key = '') => {
		let route = this.findRouteDeep(name) || {}
		if (!route) {
			return this.activeRoute();
		}
		if (!key) {
			return route;
		}
		return obj.getWithDot(route,key);
	}
	
}